<nav class="_bg-white sm-max:_shadow-bottom" [ngStyle]="{'background-color': brandingService.getHeaderColor()}">
    <div class="_cursor-pointer _min-w-20" [routerLink]="['/search-listings']">
        <img app-logo [layout]="LogoLayout.Rectangle" [size]="LogoSize.Medium"/>
    </div>

    <div class="_flex _self-center">
        <ng-content></ng-content>
    </div>

    <div class="menu-items-container">

        <app-consumer-view-toggle></app-consumer-view-toggle>

        <div class="currency-select-container _cursor-pointer">
            <app-currency-select></app-currency-select>
        </div>
    
        <div class="user-profile-container _cursor-pointer">
            <app-user-pill [matMenuTriggerFor]="menu"></app-user-pill>
        </div>
    </div>

    <mat-menu #menu="matMenu" class="menu arrow-up">
        <div class="menu-main" 
             mat-menu-item
            *ngIf="hasScope('read:account')"
            [routerLink]="['/account']">Account
        </div>

        <div class="menu-main"
             mat-menu-item
             *feature="'res-141-flok-member-show-shortlist'"
             [routerLink]="['/wishlists']">
            {{ "wishlist" | businessName | upperCaseFirst }}s
        </div>

        <div class="menu-main"
             mat-menu-item
             [routerLink]="['/clientele']"
             *feature="'res-141-flok-member-show-shortlist'">
            {{ "clientele" | businessName | upperCaseFirst }}
        </div>

        <div *ngIf="hasScope('read:trip')"
            class="menu-main"
            mat-menu-item
            [routerLink]="['/my-trips']">
            Client trips
        </div>

        <div class="menu-divider"></div>

        <div class="menu-main" mat-menu-item (click)="navigateToPrivacyPolicy()">Privacy policy</div>

        <div class="menu-main" mat-menu-item (click)="navigateToTerms()">Terms & conditions</div>

        <div fxHide class="menu-main" mat-menu-item (click)="navigateToFaq()">FAQ</div>

        <div class="menu-divider"></div>

        <div class="menu-main" mat-menu-item>
            <app-logout></app-logout>
        </div>
    </mat-menu>
</nav>
